import React, { useState, useEffect } from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import DelayRender from './DelayRender';
import './SpinTheWheel.css';
import useBank from './useBank';
import { formatMoney } from '../utils/FormatUtils';
import { BET_DENOMINATIONS } from '../utils/GameConstants';

const SpinTheWheel = () => {
  const navigate = useNavigate();
  const { user, depositMoney, withdrawMoney, refreshUser } = useBank();
  const [selectedItem, setSelectedItem] = useState(null);
  const [betAmount, setBetAmount] = useState(0);
  const [resultMessage, setResultMessage] = useState('');
  const [spinning, setSpinning] = useState(false);
  const items = ['0x', '2x', '0x', '5x', '2x', '0x', '10x', '2x', '0x', '5x', '2x', '0x', '10x', '2x', '0x', '2x'];
  const segmentColors = [
    '#70707099',
    '#a2cffe99',
    '#70707099',
    '#d3d3d399',
    '#a2cffe99',
    '#70707099',
    '#ffdf8099',
    '#a2cffe99',
    '#70707099',
    '#d3d3d399',
    '#a2cffe99',
    '#70707099',
    '#ffdf8099',
    '#a2cffe99',
    '#70707099',
    '#a2cffe99'
  ];
  const weightedItems = [
    ...Array(70).fill('0x'),
    ...Array(25).fill('2x'),
    ...Array(3).fill('5x'),
    ...Array(1).fill('10x')
  ];

  const selectItem = async () => {
    if (!spinning && betAmount >= 1) {
      if (user.money < betAmount) {
        setResultMessage("Insufficient funds to place this bet.");
        return;
      }

      setSpinning(true);
      setResultMessage('');
      const selectedItem = Math.floor(Math.random() * weightedItems.length);
      const reward = weightedItems[selectedItem];
      const rewardIndex = items.indexOf(reward);
      setSelectedItem(rewardIndex);

      let winnings = 0;
      if (reward !== '0x') {
        winnings = betAmount * parseFloat(reward);
      }

      try {
        await depositMoney(betAmount);
        setTimeout(async () => {
          await withdrawMoney(winnings);
          await refreshUser();
          if (winnings > 0) {
            setResultMessage(`You won 💴 ${Math.round(winnings)}!`);
          } else {
            setResultMessage('Better luck next time!');
          }
          setSpinning(false);
        }, 4000);
      } catch (error) {
        console.error('Error handling bet:', error);
        setSpinning(false);
      }
    }
  };

  const handleBet = (amount) => {
    setBetAmount((prevBet) => prevBet + amount);
  };

  const handleClearBet = () => {
    setBetAmount(0);
  };

  const wheelVars = {
    '--nb-item': items.length,
    '--selected-item': selectedItem,
  };
  const wheelClass = spinning ? 'spin-wheel spinning' : 'spin-wheel';

  useEffect(() => {
    if (!spinning) {
      setSelectedItem(null);
    }
  }, [spinning]);

  return (
    <div className="page">
      <div className="page-container">
        <div className="casino-header">
          <div className="back-button-container">
            <FaArrowLeft className="back-button" onClick={() => navigate(-1)} />
          </div>
          <h3 className="spin-game-header">Spin The Wheel</h3>
          <p className="spin-balance">Balance: 💴 {user && typeof user.money === 'number' ? formatMoney(user.money) : '0'}</p>
        </div>
        <div className="spin-the-wheel-game">
          <div className="spin-betting-controls">
            <div className="spin-bet-buttons">
              {BET_DENOMINATIONS.map((amount, index) => (
                <div
                  key={index}
                  className={`chip chip-${amount}`}
                  onClick={() => handleBet(amount)}
                >
                  <span>{amount}</span>
                </div>
              ))}
            </div>
            <div>
              <button className="spin-start-game-button" onClick={selectItem}>
                Place Bet 💴{Math.round(betAmount)}
              </button>
              <button className="spin-clear-bet-button" onClick={handleClearBet}>Clear Bet</button>
            </div>
          </div>
          <div className="wheel-game-container">
            <div className={wheelClass} style={wheelVars}>
              {items.map((item, index) => (
                <div
                  className="spin-wheel-item"
                  key={index}
                  style={{ '--item-nb': index, backgroundColor: segmentColors[index] }}
                >
                  {item}
                </div>
              ))}
            </div>
            <div className="spin-arrow-right"></div>
          </div>
          <div className="spin-message">
            {resultMessage || <span>&nbsp;</span>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DelayRender(SpinTheWheel, 200);
